import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, map } from "rxjs";
import { AccountStructure } from "@app/models/fund-management";
import * as Transforms from '@app/utils/transforms';
import { AccountStructureService } from "../services";

@Injectable({
	providedIn: 'root',
})
export class AccountStructureResolver implements Resolve<AccountStructureResolverData> {
	constructor(private readonly accountStructureService: AccountStructureService) {}

	resolve(): Observable<AccountStructureResolverData> {
		return this.accountStructureService.getStructure().pipe(
			map((response: any) => {
				const accountStructure: AccountStructure = response?.accountStructure;
				const questionMarkMask = Transforms.toQuestionMask(accountStructure?.UnifiedAccountMask || '');
				return {
					AccountStructure: accountStructure,
					QuestionMarkMask: questionMarkMask,
				} as AccountStructureResolverData;
			})
		);
	}
}

export interface AccountStructureResolverData {
	AccountStructure: Partial<AccountStructure>;
	QuestionMarkMask: string;
}
